import Vue from 'vue'
import configs from '@/config'
import { logInfo } from '@/3rd-parties/sentry'
import { decryptAndParse } from '@/utils/decrypt.util'
import { stringToNumber } from '@/utils/string.utils'
import { captureException } from '@sentry/vue'

let resource = null

const actions = {
  createOrUpdateAudience: {
    method: 'POST',
    url: `${configs.baseUrl}/api/audiences/`,
  },
  getAudienceData: {
    method: 'GET',
    url: `${configs.baseUrl}/api/audiences/audience-data`,
  },
  getAudienceDataCDN: {
    method: 'GET',
    url: `${configs.baseUrl}/api/presentation/audience-data/{uniqueAccessCode}`,
  },
  audienceJoinPresentation: {
    method: 'POST',
    url: configs.api.joinPresentation,
  },
  pushDeviceAssociations: {
    method: 'POST',
    url: `${configs.baseUrl}/api/associate-past-audienceids/{participantDeviceID}`,
  },
}

const initResource = () => {
  resource = Vue.resource('', {}, actions)
}

const createOrUpdateAudience = async (payload) => {
  logInfo('create/update audience', payload)
  const res = await resource.createOrUpdateAudience(payload)
  return res.body
}

const getAudienceData = async (payload) => {
  const res = await resource.getAudienceData(payload)
  return res.body
}

const getAudienceDataCDN = async (uniqueAccessCode, payload = null, encrypted = false) => {
  const resp = await resource.getAudienceDataCDN({
    uniqueAccessCode,
    ...(encrypted ? { encrypted } : {}),
  }, payload)
  if (encrypted) {
    try {
      return {
        ...resp,
        body: decryptAndParse(resp.body.encrypted, stringToNumber(uniqueAccessCode)),
      }
    } catch (err) {
      // return original response if any exception occurs
      captureException(err)
    }
  }
  return resp
}

const audienceJoinPresentation = async (payload) => {
  const res = await resource.audienceJoinPresentation(payload)
  return res.body
}

const pushDeviceAssociations = async (participantDeviceID, associations) => {
  const res = await resource.pushDeviceAssociations({ participantDeviceID }, { associations })
  return res.body
}

export default {
  initResource,
  createOrUpdateAudience,
  getAudienceData,
  getAudienceDataCDN,
  audienceJoinPresentation,
  pushDeviceAssociations,
}
